export default {
  init() {
    function projectHashChange() {
      let project_nav_container = $('.grid_projects_nav'),
        project_hash = project_nav_container.find('[href=' + location.hash + ']');

      if (location.hash !== '' && project_hash.length) {
        project_hash.trigger('click');
        console.log(project_hash)
        scrollTo(project_hash)
      }
    }

    function scrollTo($selector) {
      $selector.get(0).scrollIntoView({ behavior: 'smooth' })
    }

    $(window).on('load', projectHashChange)
    $(window).on('hashchange', projectHashChange);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/home.js